'use client'

import dynamic from 'next/dynamic'

const ImageTilesCarousel = dynamic(() => import('./ImageTilesCarousel'), {
  ssr: false,
})

export default ImageTilesCarousel
